/**
 * Recycle material percentage values for collection filters.
 */

export const recycleMaterial = {
  p0: '0',
  p7point5: '7.5',
  p15: '15',
  p20: '20',
  p30: '30',
  p33: '33',
  p90: '90',
  p99: '99'
} as const;
